import type {
  BrandsResponse,
  Brand,
} from "~/types/Data/ProductManagement/Brand";

export default function useBrands() {
  const filteredBrands = useState<Brand[] | undefined>(
    "filteredBrands",
    () => [],
  );
  const { data: brands } = useNuxtData<Brand[] | undefined>("brands");
  const nuxtApp = useNuxtApp();

  const fetchBrands = async (categoryId?: string) => {
    if (nuxtApp.$features?.brands?.is_enabled) {
      const { res } = await useApi<BrandsResponse>(
        `/api/v1/brands${categoryId ? `?filter[category]=${categoryId}` : ""}`,
      );

      if (nuxtApp.$features.brands.configs?.show_empty_brands || res?.data) {
        filteredBrands.value = res?.data;
        return res?.data;
      }
    }
  };

  return {
    brands,
    filteredBrands,
    fetchBrands,
  };
}
